import { render, staticRenderFns } from "./AnnotationSimpleDetails.vue?vue&type=template&id=1a503a98&scoped=true"
import script from "./AnnotationSimpleDetails.vue?vue&type=script&lang=js"
export * from "./AnnotationSimpleDetails.vue?vue&type=script&lang=js"
import style0 from "./AnnotationSimpleDetails.vue?vue&type=style&index=0&id=1a503a98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a503a98",
  null
  
)

export default component.exports